import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["drawer", "overlay"];

  connect() {
    document.addEventListener("turbo:before-visit", this.close.bind(this));
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.close.bind(this));
  }

  open() {
    this.drawerTarget.classList.remove("translate-x-full");
    this.drawerTarget.classList.add("translate-x-0");
    this.overlayTarget.classList.remove("opacity-0", "pointer-events-none");
    this.overlayTarget.classList.add("opacity-100");
    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.drawerTarget.classList.remove("translate-x-0");
    this.drawerTarget.classList.add("translate-x-full");
    this.overlayTarget.classList.remove("opacity-100");
    this.overlayTarget.classList.add("opacity-0", "pointer-events-none");
    document.body.classList.remove("overflow-hidden");
  }
}
